module.exports = __webpack_public_path__ + "img/Viber.9a664370.svg";